<div>
    <app-header-and-menu [openMenu]="onSideNavChange"></app-header-and-menu>
    <mat-sidenav-container class="sidenav-container" autosize>
        <mat-sidenav #leftSidenav mode="side" opened>
            <app-left-menu></app-left-menu>
        </mat-sidenav>
        <mat-sidenav-content
            [@onMainContentChange]="onSideNavChange ? 'open' : 'close'"
        >
            <div class="main_content">
                <div style="padding: 32px">
                    <router-outlet></router-outlet>
                </div>
            </div>
        </mat-sidenav-content>
    </mat-sidenav-container>
</div>
